import "../../styles/pages.css";
import "../../styles/banner.css";
import PortfolioImg from "../../assets/images/portfolio.png";
import Calculator from "../ui/Calculator";

const Banner = ({ backgroundImage, title, description }) => {
  return (
    <div className="page-banner" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="banner-content">
        <h1>{title}</h1>
        {typeof description === "string" ? <p>{description}</p> : Array.isArray(description) ? description.map((line, index) => <p key={index}>{line}</p>) : null}
      </div>
    </div>
  );
};

const Simulator = () => {
  const bannerDescription = ["에코팜은 현장의 소리를 기술로 품어냅니다.", "농가의 현실에 맞춘 설계와 철저한 시공 품질로, 믿을 수 있는 온실 환경을 제공합니다."];

  return (
    <div className="portfolio-container">
      <Banner backgroundImage={PortfolioImg} title="계산기" description={bannerDescription} />
      <Calculator />
    </div>
  );
};

export default Simulator;